import apiClient from './apiClient';

class SuperAdminSetupService {
  async getSetupTenants(search = '', skipCount = 0, pageSize = 10) {
    const params = {
      Search: search,
      SkipCount: skipCount,
      pageSize: pageSize
    };
    
    const response = await apiClient.get('/api/super-admin/setup/tenants', { params });
    return response.data;
  }

  async getSetupTenantDetails(tenantId) {
    const response = await apiClient.get(`/api/super-admin/setup/tenants/${tenantId}`);
    return response.data;
  }

  async getNozzleClientTenants(search = '', skipCount = 0, pageSize = 10) {
    const params = {
      Search: search,
      SkipCount: skipCount,
      pageSize: pageSize
    };
    
    const response = await apiClient.get('/api/supplier/super-admin-setup/nozzle-client-tenants', { params });
    return response.data;
  }

  async getNozzleClientTenantSetup(tenantId) {
    const response = await apiClient.get(`/api/supplier/super-admin-setup/nozzle-client-tenant-setup/${tenantId}`);
    return response.data;
  }

  async testLogin(loginData) {
    const response = await apiClient.post('/api/super-admin/setup/test-login', loginData);
    return response.data;
  }

  async validateCredentials(credentialsData) {
    const response = await apiClient.post('/api/supplier/super-admin-setup/validate-credentials', credentialsData);
    return response.data;
  }

  async createNozzleClientTenant(tenantData) {
    const response = await apiClient.post('/api/supplier/super-admin-setup/nozzle-client-tenant', tenantData);
    return response.data;
  }

  async createSettings(settingsData) {
    const response = await apiClient.post('/api/super-admin/setup/create-settings', settingsData);
    return response.data;
  }

  async create(createData) {
    const response = await apiClient.post('/api/super-admin/setup/create', createData);
    return response.data;
  }

  // Get tenant settings
  async getTenantSettings(tenantId) {
    const response = await apiClient.get(`/api/supplier/super-admin-setup/tenant-settings/${tenantId}`);
    return response.data;
  }

  // Update tenant settings
  async updateTenantSettings(settingsData) {
    const response = await apiClient.post('/api/supplier/super-admin-setup/tenant-settings', settingsData);
    return response.data;
  }
}

export default new SuperAdminSetupService();
